import { extractEventIdFromPath, isEventPath } from "@/lib/analytics";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ClickableEventLinkProps {
  path: string;
  eventTitles: Record<string, string>;
  onEventClick: (eventId: string) => void;
  className?: string;
  maxLength?: number;
}

export const ClickableEventLink = ({
  path,
  eventTitles,
  onEventClick,
  className,
  maxLength = 30,
}: ClickableEventLinkProps) => {
  const eventId = extractEventIdFromPath(path);
  const isEvent = isEventPath(path);

  if (isEvent && eventId) {
    const title = eventTitles[eventId] || path;
    const displayTitle = title.length > maxLength ? `${title.slice(0, maxLength)}...` : title;

    return (
      <Button
        variant="link"
        className={cn("p-0 h-auto text-left font-normal text-primary hover:underline", className)}
        onClick={() => onEventClick(eventId)}
        title={title}
      >
        {displayTitle}
      </Button>
    );
  }

  const displayPath = path.length > maxLength ? `${path.slice(0, maxLength)}...` : path;
  return <span className={className} title={path}>{displayPath}</span>;
};
